import { z } from 'zod';

export * from './agent-continuation-response';
export * from './ai-models';
export * from './ai-sdk-ui-messages';
export * from './channel-interaction';
export * from './connector-card-queue';
export * from './external-tool-labels';
export * from './tool-calls';

/**
 * ============================================================================
 * Document Size
 * ============================================================================
 */

/**
 * Categories for document size based on token count.
 */
export type DocumentSizeCategory = 'small' | 'medium' | 'large' | 'very-large';

/**
 * ============================================================================
 * AI Alert
 * ============================================================================
 */

/**
 * Alert variant for styling purposes.
 */
export type AIAlertVariant = 'info' | 'warning';

/**
 * Schema for AI alerts shown in chat.
 */
export const aiAlertSchema = z.object({
  id: z.string(),
  message: z.string(),
  title: z.string(),
  type: z.literal('alert'),
  variant: z.enum(['info', 'warning']),
});

export type AIAlert = z.infer<typeof aiAlertSchema>;
